<template></template>
<script>
//this component handles automatic status update when approving,rejecting,updating,etc.

import Vue from 'vue'
const signalR = require('@microsoft/signalr'); 
Vue.prototype.$signalR = signalR;

export default {
    components: {},
    data() {
        return {
            signalRConnection: null,    
        }
    },
    props: ['page_query_id'],
    methods: {
        async initializeSignalR() {
            await this.signalRConnection.start().catch(err => console.error(err));
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_STATUSMESSAGING_INVOKE,  this.page_query_id);
            
            this.signalRConnection.on(process.env.VUE_APP_HUB_STATUSMESSAGING_ALERT, data => {
                //invoke method from parent component
                //this will be triggered if user is on the page that is approved,rejected,etc
                this.$emit('refresh', data[0])
            });
        },
    },
    computed: {},
    created() {
        //signalR
        this.signalRConnection = new this.$signalR.HubConnectionBuilder()
                          .withUrl(`${process.env.VUE_APP_HUB_URL}statusmessaging`) 
                          .configureLogging(this.$signalR.LogLevel.Information) //this.$signalR.LogLevel.Error
                          .withAutomaticReconnect()
                          .build();
    },
    async mounted() { 
        await this.initializeSignalR()
    },
    destroyed() {
        this.signalRConnection = null
    },
}
</script>
